'use strict';

const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const Template = require('data/ui/template/content/item.hbs');
const OpenURI = require('data/ui/view/content/open-uri');
const ContainerRepository = require('data/domain/repository/container/index');

module.exports = Mn.View.extend({
    showItemLink: true,
    showOpenURI: true,
    tagName: 'li',
    className: function() {
        if(this.getOption('content') == this.model) {
            return 'list-item is-active';
        } else {
            return 'list-item'
        }
    },
    modelEvents: {
        'change:deleted': 'destroy'
    },
    template: Template,
    regions: {
        updatedBy: '.updatedBy',
        uri: '.uri'
    },
    behaviors: [Tooltip],
    templateContext: function() {
        const latestVersion = this.model.getLatestVersion();
        const contentType = latestVersion.getMetaData().getContentType();

        return {
            path: this.model.path(),
            contentType: contentType,
            latestVersion: latestVersion.toJSON()
        };
    },
    onRender: function() {
        const updatedBy = this.model.getLatestVersion().getUpdatedBy();
        if(updatedBy) {
            this.showChildView('updatedBy', new GroupMemberNameView({model: updatedBy}));
        }
        this.showItemLink = this.getOption('showItemLink');
        if(!this.showItemLink) {
            this.$('.list-item-header-title a')
                .click(function () {
                    return false;
                });
        }
        if(this.showOpenURI) {
            this.showChildView('uri', new OpenURI({
                version: this.model.getLatestVersion(),
                project: this.model.getProject()
            }));
        }

        if (this.getOption('content') == this.model && this.model.getContainer()) {
            const containerID = this.model.getContainer().id;
            const project = this.getOption('context').getProject();

            // 対象 Content を含む親の Container を開いた状態にする
            ContainerRepository.find(project)
                .fetchContainerOnce(containerID)
                .then(container => {
                    container.set({open: true});
                });
        }
    }
});



// WEBPACK FOOTER //
// ./data/ui/view/content/item.js